<template>
  <div
    class="display-textarea">
    <slot />
  </div>
</template>

<script>
/**
 * @description 自己評価のtextareaの値を表示する時に使うコンポーネント
 */
export default {
}
</script>

<style lang="scss" scoped>
.display-textarea {
  background-color: $grey15;
  padding: 8px;
  border-radius: 4px;
  min-height: 88px;

  white-space: pre-line;
  word-wrap: break-word;
}
</style>